import React from 'react';
import Widgets from '../Widgets';
import { CustomFilter } from '../../../components';
import ReactTable from "react-table";
import { isEqual } from 'lodash';
import { Icon } from 'semantic-ui-react';

import './WidgetTable.css';

export default class WidgetTable extends Widgets {
  componentDidUpdate(props, state) {
    if (
      (!isEqual(this.props.filters, props.filters) || ((this.state && state) && !isEqual(this.state.extraFilters, state.extraFilters)) || this.props.shouldLoadData)
      && (this.props.filtersLoaded)
    ){
      return this.props.fetchData({
        ...this.props.filters,
        ...(this.state ? this.state.extraFilters : {})
      }, this.props.id)
    }
  }

  onCustomFilterChange = (items) => {
    const extraFilters = items.reduce((acc, curr) => ({
      ...acc,
      ...(curr.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(curr.value.split('=')[0]) ? {[curr.value.split('=')[0]]: curr.value.split('=')[1]} : {})
    }), {});
    this.setState({ extraFilters, selectedFilters: items.filter(item => item.value.split('=').length === 2 && this.props.customFilterAcceptedParams.includes(item.value.split('=')[0])) });
  }

  render() {
    if (this.props.loaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetTable` : 'WidgetTable'} style={this.props.style}>
          <h1 className="title">{this.props.title}</h1><span className="actions">{this.props.onZoom ? <a onClick={this.props.onZoom}><i className="fa fa-search"></i></a> : null}<a onClick={this.downloadDataAsCSV}><i className="fa fa-download"></i></a></span>
          {this.props.customFilter ? <CustomFilter className="CustomFilter" selected={this.state && this.state.selectedFilters ? this.state.selectedFilters : []} onChange={this.onCustomFilterChange} acceptedParams={this.props.customFilterAcceptedParams} /> : null}
          <div className="table">
            <ReactTable
              data={this.props.graph}
              columns={Object.keys(this.props.graph[0] ? this.props.graph[0] : {}).map(row => ({Header: row, accessor: row}))}
              defaultPageSize={this.props.defaultPageSize}
              className="table"
              getPaginationProps={() => ({
                  nextText: <Icon name="icon1 icon1_angle-right"  />,
                  previousText: <Icon name="icon1 icon1_angle-left" />
              })}
            />
          </div>
        </div>
      );
    else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetTable` : 'WidgetTable'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetTable` : 'WidgetTable'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetTableComponent/WidgetTable.js